import { configureStore } from '@reduxjs/toolkit';
import carouselReducer from '../slices/carouselSlice';
import winnersReducer from '../slices/winnersSlice';
import recentWinnersReducer from '../slices/recentWinnersSlice';
import recomendedReducer from '../slices/recomendedSlice';
import faqReducer from '../slices/faqSlice';
import participateReducer from '../slices/participateSlice';
import promotionReducer from '../slices/promotionSlice';
import auctionsReducer from '../slices/auctionsSlice';
import newsletterReducer from '../slices/newsletterSlice';
import detailReducer from '../slices/detailSlice';
import userReducer from '../slices/userSlice';
import offerReducer from '../slices/offerSlice';
import offersSocketReducer from '../slices/offersSocketSlice';
import hasSuscriptedReducer from '../slices/hasSuscriptedSlice';
import notifyReducer from '../slices/notifySlice';
import finalWinnerReducer from '../slices/finalWinnerSlice';
import cpReducer from '../slices/postalCodeSlice';
import winnerMessageReducer from '../slices/winnerMessageSlice';
import countDownReducer from '../slices/countDownSlice';

const store = configureStore({
  reducer: {
    carousel: carouselReducer,
    winners: winnersReducer,
    recentWinners: recentWinnersReducer,
    recomended: recomendedReducer,
    faq: faqReducer,
    participates: participateReducer,
    promotions: promotionReducer,
    auctions: auctionsReducer,
    newsletter: newsletterReducer,
    detail: detailReducer,
    user: userReducer,
    offer: offerReducer,
    notify: notifyReducer,
    finalWinner: finalWinnerReducer,
    offersSocket: offersSocketReducer,
    hasSuscripted: hasSuscriptedReducer,
    cp: cpReducer,
    winnerMessage: winnerMessageReducer,
    countDown: countDownReducer,
  },
});

export default store;
